<template>
    <jet-action-section>
        <template #title>
            Danger Zone
        </template>

        <template #description>
            Workspace Deletion
        </template>

        <template #content>
            <div class="text-sm text-gray-600">
                By deleting your workspace, you delete all associated data. Think before acting, there's no turning
                back.
            </div>

            <div class="mt-5 flex items-center justify-start" v-if="canDeleteTeam && !hasActiveSubscription">
                <jet-danger-button @click="confirmTeamDeletion" :disabled="deleting">
                    Delete Workspace
                </jet-danger-button>
                <span class="ml-2 text-sm text-gray-500" v-if="deleting">Deleting...</span>
            </div>
            <div class="mt-5 flex items-center justify-start" v-else-if="canDeleteTeam && hasActiveSubscription">
                <jet-danger-button @click="notAllowed" :disabled="true">
                    Delete Workspace
                </jet-danger-button>
                <span class="ml-2 text-sm text-gray-500">You can't delete your workspace because you have an active
                    subscription: <a href="mailto:support@birdie.so" class="text-birdie-blue hover:underline">please
                        contact us</a>.</span>
            </div>
            <div class="mt-5 flex items-center justify-start" v-else>
                <jet-danger-button @click="notAllowed" :disabled="true">
                    Delete Workspace
                </jet-danger-button>
                <span class="ml-2 text-sm text-gray-500">Only the Team Owner is allowed to delete the workspace.</span>
            </div>

            <!-- Delete Team Confirmation Modal -->
            <jet-confirmation-modal :show="confirmingTeamDeletion" @close="confirmingTeamDeletion = false">
                <template #title>
                    <span class="text-sm">Permanently Delete Workspace</span>
                </template>

                <template #content>
                    <span class="text-sm">Do you confirm you want to delete this workspace? By deleting your workspace, you delete all
                    associated data. Think before acting, there's no turning back.</span>
                </template>

                <template #footer>
                    <jet-secondary-button @click="confirmingTeamDeletion = false">
                        Cancel
                    </jet-secondary-button>

                    <jet-danger-button class="ml-2" @click="deleteTeam" :class="{ 'opacity-25': deleting }"
                        :disabled="deleting">
                        I confirm
                    </jet-danger-button>
                </template>
            </jet-confirmation-modal>
        </template>
    </jet-action-section>
</template>

<script>
import JetActionSection from '@/Jetstream/ActionSection'
import JetConfirmationModal from '@/Jetstream/ConfirmationModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'

export default {
    props: ['team', 'canDeleteTeam', 'hasActiveSubscription'],

    components: {
        JetActionSection,
        JetConfirmationModal,
        JetDangerButton,
        JetSecondaryButton,
    },

    created() {
        console.log("CAN DELETE TEAM", this.canDeleteTeam)
    },

    data() {
        return {
            confirmingTeamDeletion: false,
            deleting: false,
            form: this.$inertia.form()
        }
    },

    methods: {
        confirmTeamDeletion() {
            this.confirmingTeamDeletion = true
        },
        notAllowed() {
            return
        },

        deleteTeam() {
            this.confirmingTeamDeletion = false
            this.deleting = true
            let url = this.$page.props.api_url + '/v1/team/delete';
            var params = {};
            axios.post(url, params)
                .then(response => {
                    let options = {
                        type: "default",
                        timeout: 6000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Your workspace is being deleted…", options)
                    setTimeout(() => {
                        window.location.href = '/logout'
                    }, 1000)
                })
                .catch(e => {
                    console.error(e);
                    let options = {
                        type: "danger",
                        timeout: -1,
                        position: "top-right",
                    }
                    this.$moshaToast("An error occurred while deleting your workspace", options)
                });
        },
    },
}
</script>
